const baseUrl = 'https://api.missions.anrop.se'

export function modMissionsUrl (modId: string): string { return `${baseUrl}/mods/${modId}/missions` }
export function worldsUrl (): string { return `${baseUrl}/worlds` }
export function worldMissionsUrl (worldName: string): string { return `${baseUrl}/worlds/${worldName}/missions` }
